// Vendor
import { createReducer, on } from '@ngrx/store';
// Actions
import { removeModelPortfolioToPushToIRebal, setModelPortfolioToPushToIRebal, } from './model-portfolio-to-push-to-irebal.action';
export const modelPortfolioToPushToIRebal = createReducer(null, on(setModelPortfolioToPushToIRebal, (state, action) => {
    if (action.modelPortfolio)
        return { ...action.modelPortfolio };
    return null;
}), on(removeModelPortfolioToPushToIRebal, () => {
    return null;
}));
